import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ClientService } from '../../client.service';

import { RemoteConfigAppResponse, RemoteConfigResponse } from './remote-config.model';

@Injectable()
export class RemoteConfigApi {
  private readonly baseUrl = 'remote-config/v3';

  constructor(private clientService: ClientService) {}

  /**
   * Returns list of all actions available on the service.
   */
  getEntryPoint(): Observable<RemoteConfigResponse> {
    const endpoint = `${this.baseUrl}`;

    return this.clientService.get(endpoint);
  }

  /**
   * Returns remote config object based on appId.
   * @param appId
   */
  getRemoteConfig(appId: string): Observable<RemoteConfigAppResponse> {
    const endpoint = `${this.baseUrl}/fetch?appId=${appId}`;

    return this.clientService.get(endpoint);
  }
}
